<template>
  <rest-list-page-label
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :show-dialog="showDialog"
    :labels="labels"
    :foreign-id="templateId"
    endpoint="campaign-templates"
    ref="restListPageLabel"
  >
    <template slot="actions" v-if="!readonly">
      <router-link :to="createTemplateRoute">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('CampaignTemplate_ListView_CreateTemplateButton') }}
        </el-button>
      </router-link>
    </template>
    <template slot="table">
      <rest-list-column-enum
        prop="message_type"
        :title="$t('CampaignTemplate_ListView_Type')"
        :enum="messageTypes"
        :sortable="false"
      />
      <rest-list-column
        prop="title"
        :title="$t('CampaignTemplate_ListView_Title')"
      />
      <rest-list-column-enum
        prop="is_active"
        :title="$t('CampaignTemplate_ListView_Active')"
        :width="150"
        :enum="templateStatusEnum"
      />
      <rest-list-column-labels> </rest-list-column-labels>
      <rest-list-column-actions v-if="readonly">
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
        </template>
      </rest-list-column-actions>
      <rest-list-column-actions v-else>
        <template slot-scope="scope">
          <rest-list-action-update :route="rowUpdateRoute(scope.row)" />
          <rest-list-action-copy :route="rowCopyEndpoint(scope.row)" />
          <rest-list-action
            icon="el-icon-price-tag"
            :title="$t('RestList_Action_Label')"
            :click="() => handleLabelsClick(scope.row)"
          />
          <rest-list-action-delete
            :name="scope.row.title"
            :endpoint="rowDeleteEndpoint(scope.row)"
          />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page-label>
</template>

<script>
import RestListPageLabel from '@/common/components/rest/RestListPageLabel'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionCopy from '@/common/components/rest/RestListActionCopy'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import RestListColumnLabels from '@/common/components/rest/RestListColumnLabel'
import RestListAction from '@/common/components/rest/RestListAction'
import { EventBus } from '@/core/EventBus'
import _ from 'lodash'

export default {
  name: 'TemplateListPage',

  components: {
    RestListColumnLabels,
    RestListActionDelete,
    RestListActionUpdate,
    RestListActionCopy,
    RestListActionView,
    RestListColumnActions,
    RestListColumnEnum,
    RestListColumn,
    RestListPageLabel,
    RestListAction
  },
  data() {
    return {
      showDialog: false,
      templateId: 0,
      labels: [],
      templateStatusEnum: {
        0: this.$t('CampaignTemplate_ListView_Inactive'),
        1: this.$t('CampaignTemplate_ListView_Active')
      }
    }
  },
  mounted() {
    EventBus.$on('manageLabelsDialog', () => {
      this.showDialog = false
    })

    EventBus.$on('applyLabels', () => {
      this.$refs['restListPageLabel'].$refs['list'].refresh()
      this.showDialog = false
    })
  },

  computed: {
    messageTypes() {
      return _.omit(MessageTypeLabel, 12)
    },

    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'campaign-templates',
        params: {
          expand: 'is_active'
        }
      })
    },

    createTemplateRoute() {
      return projectRoute({
        name: 'CampaignTemplates'
      })
    },

    readonly() {
      return !this.$can('CampaignTemplate:FullAccess')
    }
  },

  methods: {
    handleLabelsClick(row) {
      this.labels = row.labels
      this.templateId = row.id
      this.showDialog = true
    },

    rowViewRoute(row) {
      return projectRoute({
        name: 'CampaignTemplatesView',
        query: { id: row.id }
      })
    },

    rowUpdateRoute(row) {
      return projectRoute({
        name: 'CampaignTemplatesUpdate',
        query: { id: row.id }
      })
    },

    rowCopyEndpoint(row) {
      return projectRoute({
        name: 'CampaignTemplatesCopy',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `campaign-templates/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/templates/pages/TemplateListPage.vue